import { combineReducers } from 'redux';

import {
  ConnectedActionHandlerMap as createWithSalesOrdersReducer,
  namespace as createWithSalesOrdersNamespace,
} from './create/with-sales-orders.reducer';
import {
  ConnectedActionHandlerMap as createWithFulfillmentPlansReducer,
  namespace as createWithFulfillmentPlansNamespace,
} from './create/with-fulfillment-plans.reducer';
import {
  ConnectedActionHandlerMap as createWithoutFulfillmentPlansReducer,
  namespace as createWithoutFulfillmentPlansNamespace,
} from './create/without-fulfillment-plans.reducer';
import { ConnectedActionHandlerMap as detailsReducer, namespace as detailsNamespace } from './details/batch.details.reducer';
import { ConnectedActionHandlerMap as gridReducer, namespace as gridNamespace } from './grid/batches.grid.reducer';
import { ConnectedActionHandlerMap as navReducer, namespace as navNamespace } from './nav/batches.nav.reducer';
import { ConnectedActionHandlerMap as purchaseReducer, namespace as purchaseNamespace } from './purchase/batches.purchase.reducer';
import {
  ConnectedActionHandlerMap as lbsmReducer,
  namespace as lbsmNamespace,
} from './label-batch-status-modal/batches.label-batch-status-modal.reducer';

export const combinedReducer = combineReducers({
  [createWithSalesOrdersNamespace]: createWithSalesOrdersReducer,
  [createWithFulfillmentPlansNamespace]: createWithFulfillmentPlansReducer,
  [createWithoutFulfillmentPlansNamespace]: createWithoutFulfillmentPlansReducer,
  [detailsNamespace]: detailsReducer,
  [gridNamespace]: gridReducer,
  [navNamespace]: navReducer,
  [purchaseNamespace]: purchaseReducer,
  [lbsmNamespace]: lbsmReducer,
});

export { namespace } from './batches.reducer.metadata';
